import React from "react"
import "@/App.css"
import { BrowserRouter, Routes, Route } from "react-router-dom"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { WagmiProvider } from "wagmi"
import { config } from "./config/wagmi"
import { AuthProvider } from "./context/AuthContext"
import { CurrencyProvider } from "./context/CurrencyContext"
import { TenantProvider } from "./context/TenantContext"
import { Toaster } from "./components/ui/sonner"

// Pages
import { LandingPage } from "./pages/LandingPage"
import { MarketplacePage } from "./pages/MarketplacePage"
import { PropertyDetailPage } from "./pages/PropertyDetailPage"
import { KYCPage } from "./pages/KYCPage"
import { InvestorDashboard } from "./pages/InvestorDashboard"
import { IssuerDashboard } from "./pages/IssuerDashboard"
import { AdminDashboard } from "./pages/AdminDashboard"
import TenantAdminPage from "./pages/TenantAdminPage"
import SuperAdminPage from "./pages/SuperAdminPage"
import HowItWorksPage from "./pages/HowItWorksPage"
import InvestorsPage from "./pages/InvestorsPage"
import OwnersPage from "./pages/OwnersPage"

const queryClient = new QueryClient()

function App() {
  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <TenantProvider>
          <CurrencyProvider>
          <div className="App">
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/marketplace" element={<MarketplacePage />} />
                <Route path="/property/:id" element={<PropertyDetailPage />} />
                <Route path="/kyc" element={<KYCPage />} />
                <Route path="/investor" element={<InvestorDashboard />} />
                <Route path="/issuer" element={<IssuerDashboard />} />
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/tenant-admin" element={<TenantAdminPage />} />
                <Route path="/super-admin" element={<SuperAdminPage />} />
                <Route path="/how-it-works" element={<HowItWorksPage />} />
                <Route path="/investors" element={<InvestorsPage />} />
                <Route path="/owners" element={<OwnersPage />} />
              </Routes>
            </BrowserRouter>
            <Toaster 
              position="top-right" 
              toastOptions={{
                style: {
                  background: '#0F0F11',
                  border: '1px solid #27272A',
                  color: '#EDEDED',
                }
              }}
            />
          </div>
        </CurrencyProvider>
        </TenantProvider>
        </AuthProvider>
      </QueryClientProvider>
    </WagmiProvider>
  )
}

export default App
